import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetRolesById } from "../../../lib/data";
import EditRolesUi from "../../../ui/rolesui/EditRolesUi";
import i18n from "../../../lib/i18n";

export default function EditRoles() {

    const { roleId } = useParams();
    const [rolesData, setRolesData] = useState({});
    const t = i18n.t.bind(i18n); 

    useEffect(() => {
        handleApi();
    }, [])

    const handleApi = async () => {
        const roleData = await GetRolesById(roleId);
        setRolesData(roleData);
    };

    return (
        <div className="p-5 my-3 mx-6 rounded-lg bg-thirdly">
            <div>
                <h1 className="sm:text-[30px] text-[24px] text-center text-gray pt-1 sm:pb-8 pb-4">{t("edit_page_title.role")}</h1>
                <EditRolesUi data={rolesData} />
            </div>
        </div>
    );
};